import { useContext } from 'react';

import classNames from 'classnames';
import moment from 'moment';
import { Alert } from 'reactstrap-alert';
import Nav from 'reactstrap/es/Nav';
import NavItem from 'reactstrap/es/NavItem';
// import './sidebar.less';
import MenuManager from '@yooink/youtils/es/MenuManager';
import { Link, withRouter } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import Checkbox from '@yooink/youi/es/Checkbox';
import DarkModeToggle from 'react-dark-mode-toggle';
import { NavLink } from './NavLink';
import SubMenu from './SubMenu';
import iconLogout from '../../../../../Images/icon/logout.svg';
import { UserContext } from '../../../../../Components/UserContext';
import { getAvatarUrl } from './GetAvatarUrl';
import { useLocalStorage } from '../../../../../Components/useLocalStorage';

const appVersion = () => {
	Alert({
		title: 'О сборке',
		message: <pre>{JSON.stringify(window.APP_INFO, null, 4)}</pre>
	});
};

function SideBar (props) {
	const { isOpen, toggle } = props;
	const { user, logOut } = useContext(UserContext);
	const [darkTheme, setDarkTheme] = useLocalStorage('isDarkTheme', false);

	let { groups, items } = MenuManager.instance;
	groups = groups.map((group) => {
		group.children = items.filter((e) => e.parent === group.key);
		return group;
	});
	items = items.filter((e) => !e.parent);

	const menuItems = [
		...items.map((item) => ({
			type: 'item',
			item,
			position: item.position || 0
		})),
		...groups.map((group) => ({
			type: 'group',
			item: group,
			position: group.position || 0
		}))
	].sort((a, b) => (a.position > b.position ? 1 : -1));
	const avatar = getAvatarUrl(user);
	return (
		<div className={classNames('sidebar', { 'is-open': isOpen })}>
			<div className="sidebar_header">
				<a color="info" onClick={toggle} style={{ color: '#fff' }}>
					Yo(!)ink
				</a>
			</div>
			<div className="sidebar_profile">
				<div className="sidebar_profile-images">
					{avatar && <img src={avatar} alt={`Аватар пользователя ${user.fullName}`} />}

				</div>
				<div className="sidebar_profile-info">
					<div className="name">Hi, {user.fullName}</div>
					<div>
						<DarkModeToggle
							onChange={setDarkTheme}
							checked={darkTheme}
							A
							size={45}
						/>
					</div>
				</div>
			</div>
			<Nav vertical className="sidebar_list pb-3">
				<NavItem className="sidebar_list-item">
					<NavLink to="/">
						<span>Главная</span>
					</NavLink>
				</NavItem>
				{menuItems.map((elem) => {
					if (elem.type === 'item') {
						const { item } = elem;
						return (
							<ListLink
								href={item.path}
								name={item.name}
								icon={item.icon}
								showBadge={item.showBadge}
								badgeValue={item.badgeValue}
							/>
						);
					} if (elem.type === 'group') {
						const group = elem.item;
						return (
							<SubMenu title={group.name} icon={group.icon} key={`gen-menu-${group.key}`}>
								{group.children.map((item) => (
									<ListLink
										href={item.path}
										name={item.name}
										icon={item.icon}
										showBadge={item.showBadge}
										badgeValue={item.badgeValue}
									/>
								))}
							</SubMenu>
						);
					}
					return null;
				})}
				<NavItem
					className="sidebar_list-item"
					onClick={logOut}
				>
					<div className="nav-link">
						<ReactSVG src={iconLogout} />
						<span>LogOut</span>
					</div>
				</NavItem>
			</Nav>
			<Nav
				vertical
				className="list-unstyled pb-3"
			>
				<NavItem onClick={appVersion}>
					{window.APP_INFO.GIT_BRANCH}-{window.APP_INFO.GIT_SHORT_COMMIT || '???'} {window.APP_INFO.APP_VERSION}
					<br />
					{moment(window.APP_INFO.BUILD_DATE).format('DD MMM YYYY HH:mm')}
				</NavItem>
			</Nav>
		</div>
	);
}

const ListLink = withRouter(({ location, href, icon, name, showBadge, badgeValue }) => (
	<NavItem
		className={classNames('sidebar_list-item', {
				active: location.pathname === href
			})}
		action
	>
		<Link to={href} className="nav-link">
			{icon}
			<span>{name}</span>
			{showBadge && (
			<div className="sidebar_item-badge">
				<span>{badgeValue}</span>
			</div>
				)}
		</Link>
	</NavItem>
));

export default SideBar;
